import { useState } from 'react';
import { useRouter } from 'next/router';

import { Button } from '@playbooks/ui/components/button';
import { Icon } from '@playbooks/ui/components/icon';
import { cn } from '@playbooks/ui/lib/utils';

import { SearchModal } from 'components/search/search-modal';
import { useKeyDown } from 'hooks';

const DocsSearch = ({ prominent = false }: { prominent?: boolean }) => {
	const [open, setOpen] = useState(false);
	const router = useRouter();

	useKeyDown(
		event => {
			if (event.key.toLowerCase() === 'k' && (event.metaKey || event.ctrlKey)) setOpen(true);
			if (event.key === 'Escape') setOpen(false);
		},
		[router.asPath],
	);

	// Theme
	const classNames = {
		root: cn(
			'justify-start gap-2 text-foreground-body',
			prominent ? 'w-full' : 'size-8 px-0 sm:h-9 sm:w-64 sm:px-4 lg:w-80',
		),
		label: cn('grow text-left font-normal', !prominent && 'hidden sm:inline'),
		shortcut: cn(
			'rounded-control border bg-surface px-1.5 py-0.5 font-sans text-[10px] font-medium',
			prominent ? 'inline-flex' : 'hidden sm:inline-flex',
		),
	};

	// Render
	return (
		<>
			<Button variant='outline' size='sm' onClick={() => setOpen(true)} className={classNames.root}>
				<Icon type='far' icon='magnifying-glass' aria-hidden />
				<span className={classNames.label}>Search documentation...</span>
				<kbd className={classNames.shortcut}>⌘K</kbd>
			</Button>
			<SearchModal tableName='articles' placeholder='Search documentation...' open={open} setOpen={setOpen} />
		</>
	);
};

export { DocsSearch };
